import { render, staticRenderFns } from "./ModalConfirmAction.vue?vue&type=template&id=6b87495c"
import script from "./ModalConfirmAction.vue?vue&type=script&lang=js"
export * from "./ModalConfirmAction.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmAction.vue?vue&type=style&index=0&id=6b87495c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports